.root {
  position: relative;
  top: 1px;
  display: inline-block;
  margin-left: 0.5rem;
  color: var(--muted-old);

  @media print {
    display: none;
  }
}
